import { render } from "./minicart.vue?vue&type=template&id=1428e483"
import script from "./minicart.vue?vue&type=script&lang=js"
export * from "./minicart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__